var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Button, PageHeading } from '../../shared';
import { ApplicationFormStatus, services } from '../../../shared';
import { Workflow, CompleteCase } from '../../sections';
import { CompletionContainer } from '../../shared';
import { ApplicationStatus } from '../../../shared/types/enums';
import { NoPermission } from '../../sections/no-permission-modal/no-permission';
import '../../sections/question-sets/question-set/question-set.scss';
import { pageContentValues } from '../../../shared/types/constants';
import { LoaderForDialog } from '../../../shared/utils/loader/loaders/loader-dialog';
import { useAppSelector } from '../../../components/app/hooks';
export var CompleteCasePage = function (_a) {
    var _b, _c, _d;
    var location = _a.location;
    var _e = useParams(), caseId = _e.caseId, loanPurposeId = _e.loanPurposeId;
    var _f = useState([]), steps = _f[0], setWorkflowSteps = _f[1];
    var _g = useState([]), setPages = _g[1];
    var _h = useState(), setWorkflowStep = _h[1];
    var _j = useState(), caseDetails = _j[0], setCaseDetails = _j[1];
    var _k = useState(), modalVisible = _k[0], setModalVisible = _k[1];
    var _l = useState(''), societyName = _l[0], setSocietyName = _l[1];
    var _m = useState(false), noAuthSet = _m[0], setNoAuthSet = _m[1];
    var _o = useState(), brokerStatusId = _o[0], setBrokerStatusId = _o[1];
    var isLoaderEnabled = useAppSelector(function (state) { return state.loadingStore.isLoaderEnabled; });
    var defaultApplicationWorkflow = {
        id: 0,
        formType: "applicants",
        stepOrder: 0,
        isActive: false,
        formId: 0,
        applicationFormStatus: ApplicationFormStatus.Completed,
        disable: false,
    };
    var fetchApplicationProgressBarSteps = function (caseId, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var applicationWorkflow, currentStep;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getDynamicWorkflow(caseId, loanPurposeId)];
                case 1:
                    applicationWorkflow = (_a.sent()).data;
                    setWorkflowSteps(__spreadArray([defaultApplicationWorkflow], applicationWorkflow.workflowSteps, true));
                    currentStep = applicationWorkflow.workflowSteps[applicationWorkflow.workflowSteps.length - 1];
                    setWorkflowStep(currentStep);
                    return [2 /*return*/, currentStep];
            }
        });
    }); };
    var fetchPageWithStatus = function (caseId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var pageWithStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getPagesWithStatus(caseId, formId)];
                case 1:
                    pageWithStatus = (_a.sent()).data;
                    setPages(pageWithStatus);
                    return [2 /*return*/, pageWithStatus[0].sections[0].id];
            }
        });
    }); };
    var fetchCaseDetails = function (id, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var c;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getCase(id)];
                case 1:
                    c = (_a.sent()).data;
                    location.state = {
                        applicants: c.applicants,
                        case: c,
                        loanPurposeId: loanPurposeId,
                    };
                    setCaseDetails(c);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchSocietyName = function () { return __awaiter(void 0, void 0, void 0, function () {
        var societyName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getModuleText(pageContentValues.societyName.content)];
                case 1:
                    societyName = (_a.sent()).data;
                    setSocietyName(societyName.description);
                    return [2 /*return*/];
            }
        });
    }); };
    var loanPurpose = Number(loanPurposeId);
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var id, applicationProgressBarSteps;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = Number(caseId);
                    return [4 /*yield*/, fetchApplicationProgressBarSteps(id, loanPurpose)];
                case 1:
                    applicationProgressBarSteps = _a.sent();
                    //await fetchPageWithStatus(id, applicationProgressBarSteps.formId);
                    return [4 /*yield*/, fetchCaseDetails(id, loanPurpose)];
                case 2:
                    //await fetchPageWithStatus(id, applicationProgressBarSteps.formId);
                    _a.sent();
                    return [4 /*yield*/, fetchSocietyName()];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var hideModal = function () {
        setModalVisible(false);
    };
    var showModal = function () {
        setModalVisible(true);
        setNoAuthSet(false);
    };
    var fetchBrokerStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var brokerDetail;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getBroker()];
                case 1:
                    brokerDetail = (_a.sent()).data;
                    if (brokerDetail.statusID === 4) {
                        setBrokerStatusId(true);
                    }
                    else {
                        setBrokerStatusId(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchBrokerStatus();
        location.state = {
            applicants: [],
            case: null,
            loanPurposeId: Number(loanPurposeId),
        };
        fetchData();
    }, [brokerStatusId, caseId]);
    return (React.createElement(React.Fragment, null, brokerStatusId ? (React.createElement(NoPermission, { show: noAuthSet })) : (React.createElement(React.Fragment, null,
        React.createElement(Workflow, { caseId: (_d = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : Number(caseId), loanPurposeId: loanPurpose, setActiveWorkflowStep: setWorkflowStep, setWorkflowSteps: setWorkflowSteps, location: location }),
        React.createElement("div", { className: "l-question-sets" },
            React.createElement("div", { className: "l-question-sets__content" },
                React.createElement("div", { className: "l-question-sets__questions" },
                    React.createElement("div", { className: "l-question-sets__header" },
                        React.createElement(PageHeading, { headingLevel: 2, title: 'Complete Full Mortgage Application', icon: 'cases', mb: 6 })),
                    React.createElement(Container, { ctabar: true },
                        React.createElement("div", { className: "c-question-set" },
                            noAuthSet ? (React.createElement(NoPermission, { show: noAuthSet })) : (React.createElement(CompleteCase, { societyName: societyName, show: modalVisible, handleClose: hideModal, setNoAuth: setNoAuthSet })),
                            brokerStatusId == null ? (isLoaderEnabled ? (React.createElement(LoaderForDialog, null)) : (React.createElement("p", { className: "c-question-set__loader" }, "loading...."))) : (!noAuthSet && (React.createElement(CompletionContainer, { heading: "Are you ready to submit this mortgage case to ".concat(societyName, "?"), text: "Your case is ready to submit. Once it has been submitted you will not be able to edit any details." },
                                React.createElement(Button, { variant: "primary", type: "button", onClick: showModal, width: "full", disabled: ((caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicationstatus) == ApplicationStatus.Completed ||
                                        (caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicationStatusId) == ApplicationStatus.Completed ||
                                        (caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicationStatusId) == ApplicationStatus.Submitted) &&
                                        steps.filter(function (step) { return !step.isComplete; }).length > 0 }, "Submit Case")))))))))))));
};
